// utils/AuthHelper.js
export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem("token");
};

export const getUserType = () => {
  const user = getCurrentUser();
  return user?.user_type || localStorage.getItem("user_role");
};

export const getUserOrganization = () => {
  const user = getCurrentUser();
  if (user?.organization) {
    return user.organization;
  }

  try {
    const orgStr = localStorage.getItem("user_organization");
    return orgStr ? JSON.parse(orgStr) : null;
  } catch (error) {
    return null;
  }
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const hasPermission = (requiredTypes = []) => {
  const userType = getUserType();
  return requiredTypes.includes(userType);
};
